module.exports = __webpack_public_path__ + "static/img/shezhi_tixian.54bf12c2.png";